export default function clientConfig() {
  const config = {
    codCliente: 2153, // HMG 9153 // PRD 2153
    plano: 1, // Patrocinado
    tipo: 1,
  }

  return config
}
